import React from 'react';
import { Calendar } from 'lucide-react';

const BookingTrendChart = ({ trends = [] }) => {
 if (!trends || trends.length === 0) {
 return (
 <div className="product-panel p-4 sm:p-6">
 <h3 className="mb-4 text-lg font-semibold text-ink">Booking Trend</h3>
 <div className="py-12 text-center">
 <Calendar className="mx-auto mb-4 h-12 w-12 text-ink-tertiary" />
 <p className="text-ink-secondary">No booking data available</p>
 </div>
 </div>
 );
 }

 const bookingData = trends.map(item => ({
 period: item.period,
 count: Number(item.count || 0)
 }));

 const maxCount = Math.max(...bookingData.map(d => d.count), 1);

 return (
 <div className="product-panel p-4 sm:p-6">
 <div className="mb-4 flex items-center justify-between">
 <h3 className="text-lg font-semibold text-ink">Booking Trend</h3>
 <Calendar className="h-5 w-5 text-ink-tertiary" />
 </div>
 <div className="space-y-3">
 {bookingData.map((item, index) => {
 const percentage = maxCount > 0 ? (item.count / maxCount) * 100 : 0;
 return (
 <div key={index} className="space-y-1">
 <div className="flex items-center justify-between text-sm">
 <span className="font-medium text-ink-secondary">{item.period}</span>
 <span className="font-semibold text-ink">{item.count} bookings</span>
 </div>
 <div className="h-2.5 w-full rounded-full bg-surface-muted">
 <div
 className="h-2.5 rounded-full bg-ink transition-all duration-500"
 style={{ width: `${percentage}%` }}
 />
 </div>
 </div>
 );
 })}
 </div>
 <div className="mt-4 border-t border-border pt-4">
 <div className="flex items-center justify-between text-sm">
 <span className="text-ink-secondary">Total</span>
 <span className="text-lg font-bold text-ink">
 {bookingData.reduce((sum, item) => sum + item.count, 0)} bookings
 </span>
 </div>
 </div>
 </div>
 );
};

export default BookingTrendChart;
